enum FlowType {
  BEST_AVAILABLE = 'BEST_AVAILABLE',
  PICK_A_SEAT_2D = 'PICK_A_SEAT_2D',
  PICK_A_SEAT_3D = 'PICK_A_SEAT_3D',
  RESALE_LIST = 'RESALE_LIST',
}
export { FlowType };
